"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prune = void 0;
const prune = (list) => list.filter((t) => t != null);
exports.prune = prune;
